import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var mobileNumberVerificationConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: false,
  stepDetailsProps: {
    title: 'STEP 1',
    heading: 'Mobile number re-verification',
    avatarIcon: 'ContactsButtonIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  inputsDataProps: {
    mobileNumber: {
      label: 'Mobile number*',
      hintText: 'Enter the number that requires re-verification',
      inputRegex: '^[6-9]{1}[0-9]*$',
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter 10-digit mobile number',
      validationRegex: '^\\d{10}$',
      maxLength: 10
    },
    name: {
      label: 'Name',
      isDisabled: true
    }
  },
  submitButtonProps: {
    leftCta: {
      version: 'variable-width',
      title: 'Verify via OTP',
      size: 'md'
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};